import Vue from "vue";
import axios from "axios";

export default {
  name: "StationUtils",
  data: function () {
    return {
      stationDeclared: null,
      empStations: [],
      userProf: {},
    };
  },
  created() {
    this.userProf = this.$store.getters.getUserProfile;

    let stations = this.$store.getters.getUserStations;
    this.stationDeclared = stations.declared;
  },
  methods: {
    async getStations() {
      return await axios.post('/EmployeeApplication/GetAllStations')
        .then(response => {
          if (response.status == 200 && response.data.data.status == 0) {
            this.empStations = response.data.items;

            if (this.stationDeclared.id < 0) {
              if (this.userProf && this.userProf.employeeStationId != null)
                this.stationDeclared = this.empStations.filter(e => e.id == this.userProf.employeeStationId)[0];
              else
                this.stationDeclared = this.empStations[0];
            }

            let stations = this.$store.getters.getUserStations;
            this.saveStations(this.stationDeclared, stations && stations.assigned.id > -1 ? stations.assigned : this.stationDeclared);

            return true;
          }
        })
        .catch(error => {
          this.$oldAlertMsg(error, 4);
          return false;
        });
    },
    async getStationFromServer(appId) {
      return await  axios.get('/EmployeeApplication/GetAppAssignedStation?appId=' + appId)
        .then(response => {
          if (response.status == 200 && response.data.data.status == 0) {
            let station = this.empStations.filter(e => e.id == response.data.assignedStationId);
            if (station && station.length > 0) {
              this.saveStations(station[0]);
              this.stationDeclared = { ...station[0] };
            }   
            return true;
          }

          return false
        })
        .catch(err => { return false});
    },

    saveStations(declared, assigned) {
      if (!declared || declared.id == null || declared.id < 0)
        return;

      if (!assigned)
        assigned = this.empStations.filter(e => e.id == this.userProf.employeeStationId)[0];

      this.stations = { declared, assigned }
      this.$store.commit('setUserStations', this.stations);
    },
    setAppAssignedStation(appId) {
      let param = { assignedStationId: this.stations.declared.id, appId }
      axios.post('/EmployeeApplication/SetAppAssignedStation', param)
        .then(response => { })
        .catch(err => { });
    }
  },
};
